import {Injectable} from '@angular/core';
import {PostmethodService} from 'src/app/app-config/postmethod.service';
import {RequestModel} from 'src/app/models/RequestModel';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class OrderNOtificationService {
  constructor(private ws: PostmethodService) {}

  getAppOrderNotification() {
    return this.ws.wsGet(environment.webServiceUrl + 'getTodaysOrderCount');
  }
}
